
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import CreateSkuMapping from '@/views/front/stock/skumapping-add.vue'
    import TotalInStock from '@/views/front/stock/totalinstock-history.vue'
    import TotalOutStock from '@/views/front/stock/totaloutstock-history.vue'
    import LaveStock from '@/views/front/stock/lavestock-history.vue'
    import SafeStock from '@/views/back/stock/safestock-add.vue'
    import LookSkuMapping from '@/views/front/stock/skumapping-look.vue'
    import EditStockProduct from '@/views/back/stock/stockproduct-edit.vue'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import appconst from '@/lib/appconst';
    import moment from 'moment'
    Vue.use(Preview);

    class PagepublicstockproductRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        productName: string;
        storeId?: number;
        productSku: string;
        minSafeStock?: number;
        maxSafeStock?: number;
        productNo: string;
    }

    @Component({
        name: "publicstockproduct",
        components: { CreateSkuMapping, LookSkuMapping, TotalInStock, TotalOutStock, LaveStock, SafeStock, EditStockProduct }
    })
    export default class publicstockproduct extends AbpBase {
        editModalShow: boolean = false;
        supplyModalShow: boolean = false;
        totalinstockModalShow: boolean = false;
        totaloutstockModalShow: boolean = false;
        lookModalShow: boolean = false;
        lavestockModalShow: boolean = false;
        safeStockModalShow: boolean = false;
        stockProductModalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        pagerequest: PagepublicstockproductRequest = new PagepublicstockproductRequest();
        IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
        stockstatusList = Enums.getEnum(Enums.StockStatus, true);
        //creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        creationTime: Date[];
        createModalShow: boolean = false;
        uploadURL: string = "";
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        get list() {
            return this.$store.state.publicstockproduct.list;
        };
        get loading() {
            return this.$store.state.publicstockproduct.loading;
        }

        pageChange(page: number) {
            this.$store.commit('publicstockproduct/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('publicstockproduct/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.user.currentPage = 1;
            this.getpage();
        }

        handleSuccess(res, file) {
            if (res.success) {
                this.$Message.success('导入成功。');
            }
        }

        handleError(res, file) {
            this.$Message.error('导入失败。');
        }

        async changeWareHouse() {
            this.uploadURL = appconst.remoteServiceBaseUrl + "api/services/app/PublicStockProduct/UploadProduct?Wid=" + this.pagerequest.storeId;
        }

        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            if (this.creationTime &&this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime &&this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }
            await this.$store.dispatch({
                type: 'publicstockproduct/getAll',
                data: this.pagerequest
            })
        }

        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length == 1) {
                this.pagerequest.storeId = this.storeaddressList[0].id;
                this.changeWareHouse();
            }
            else {
                this.storeaddressList.push(a);
                this.pagerequest.storeId = null;
            }
        }

        async setPrice() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];

            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }
            this.$store.state.publicstockproduct.publicStockEdit = {};
            this.$store.state.publicstockproduct.publicStockEdit.ids = ids;
            this.stockProductModalShow = true;
        }


        async setSafeStock() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];

            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }
            this.$store.state.publicstockproduct.publicStockEdit = {};
            this.$store.state.publicstockproduct.publicStockEdit.ids = ids;
            this.safeStockModalShow = true;
        }

        async setDelete() {
            var _this = this;
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];

            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }

            _this.$Modal.confirm({
                title: "是否删除", content: "是否批量删除选中？", width: 800, onOk: async () => {
                    setTimeout(async () => {
                        var data = { ids: ids, IsDelete: true };
                        await this.$store.dispatch({
                            type: 'publicstockproduct/edit',
                            data: data
                        });
                        this.$Message.info("删除成功！");
                    }, 500);

                }, onCancel: () => {
                }
            });
        }

        async setIsAvailable(dataValue) {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];

            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }
            var data = { ids: ids, IsAvailable: dataValue };
            await this.$store.dispatch({
                type: 'publicstockproduct/edit',
                data: data
            });
        }

        async setAvailable() {
            this.setIsAvailable(true);
        }

        async setNoAvailable() {
            this.setIsAvailable(true);
        }

        async stockAvailable(data) {
            await this.$store.dispatch({
                type: 'publicstockproduct/updateStockProductDisable',
                data: { stockId: data.id, }

            });
            this.getData();
            this.getpage();
        }

        async EditSafeStockNum(data: any) {
            this.$store.state.publicstockproduct.id = data.id;
            this.$store.state.publicstockproduct.safeStockNum = data.safeStock;
            this.safeStockModalShow = true;
        }

        async EditProduct(data: any) {
            this.$store.state.publicstockproduct.id = data.id;
            this.$store.state.publicstockproduct.purchaseCost = data.purchaseCost;
            this.stockProductModalShow = true;
        }

        async stockNotAvailable(data) {
            await this.$store.dispatch({
                type: 'publicstockproduct/UpdateStockProductNotAvailable',
                data: { stockId: data.id, }

            });
            this.getData();
            this.getpage();
        }

        async stockDisable(data) {
            this.$Modal.confirm({
                title: "禁用产品", content: "确定将【" + data.productName + "】标记为禁用，如果标记为禁用，则不可恢复，将停止仓储费扣费!", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'publicstockproduct/updateStockProductDisable',
                        data: { stockId: data.id, }

                    });
                    this.getData();
                    this.getpage();
                }
            });

        }
        async showmodel(data: any, type: number) {
            this.$store.state.publicstockproduct.id = data.id;
            if (type == 1) {
                //入库总量历史
                this.totalinstockModalShow = true;
            }
            else if (type == 2) {
                //出库总量历史
                this.totaloutstockModalShow = true;
            }
            else {
                //库存量历史
                this.lavestockModalShow = true;
            }
        }
        async stockup(data: any) {
            this.$store.state.publicstockproduct.id = data.id;

            this.supplyModalShow = true;
        }
        get pageSize() {
            return this.$store.state.publicstockproduct.pageSize;
        }
        get totalCount() {
            return this.$store.state.publicstockproduct.totalCount;
        }
        get currentPage() {
            return this.$store.state.publicstockproduct.currentPage;
        }
        columns = [
            //{
            //    title: '国内物流单号',
            //     key: 'logisticsNumber',
            //    width: 150,

            //    },
            {
                type: 'selection',
                width: 60,
                align: 'center',

            },
            {
                title: '备货入库仓库',
                key: 'storeName',
                width: 150,
                fixed: 'left',
            },
            //{
            //    title: '产品类型',
            //    width: 90,
            //    key: 'productType',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name);
            //    }
            //    },
            {
                title: '产品编号',
                key: 'productNo',
                width: 170,
            },
            {
                title: '产品状态',
                key: 'stockStatus',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', Enums.StockStatus.filter(function (item) { return item.value == params.row.stockStatus })[0].name);
                }
            },
            {
                title: '产品图片',
                key: 'productImgGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.productImgGuid) {
                        var data = { imageGuid: params.row.productImgGuid, url: null };
                        var url = "";
                        if (params.row.productImgGuid.indexOf("http") != -1) {
                            url = params.row.productImgGuid;
                        }
                        else {
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            url = data.url;
                        }
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "cp"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '产品Sku',
                key: 'productSku',
                width: 250,
            },
            {
                title: '商品名称',
                key: 'productName',
                width: 250,
            },
            {
                title: '安全库存',
                key: 'safeStock',
                width: 100,
            },
            {
                title: '入库总量',
                key: 'totalStorage',
                width: 100,
                render: (h: any, params: any) => {
                    var a = 'red';
                    return h('a', { on: { click: () => { this.showmodel(params.row, 1) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.totalStorage);
                }
            },
            {
                title: '出库总量',
                key: 'totalOutgoing',
                width: 100,
                render: (h: any, params: any) => {
                    var a = 'red';
                    return h('a', { on: { click: () => { this.showmodel(params.row, 2) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.totalOutgoing);
                }
            },
            {
                title: '库存量',
                key: 'inventory',
                width: 100,
                render: (h: any, params: any) => {
                    var a = 'red';
                    return h('a', { on: { click: () => { this.showmodel(params.row, 3) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.inventory);
                }
            },
            {
                title: '扣款价格(人民币)',
                key: 'purchaseCost',
                width: 100,

            },
            {
                title: '货架位置',
                key: 'shelfPosition',
                width: 200,

            },
            //{
            //    title: '扣费周期/积分',
            //    key: 'deductionCycle',
            //    width: 200,
            //},
            //    width: 200,
            //},

            //{
            //    title: '商品数量',
            //    key: 'productNums',
            //    width: 200,
            //},
            //{
            //    title: '采购成本',
            //    key: 'purchaseCost',
            //    width: 200,
            //},

            {
                title: '操作',
                width: 120,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '90px',
                                display: (data.stockStatus == 1 || data.stockStatus == 0) ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.stockDisable(data);
                                }
                            }

                        }, "标记为禁用")
                    ]
                    );
                }
            }
        ]
        async created() {
            await this.getData();
            this.getpage();
        }
    }
